import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/home',
      redirect: { name: 'home' }
    },
    {
      path: '/speaker',
      name: 'lineup',
      component: () => import(/* webpackChunkName: "lineup" */ './views/Lineup.vue'),
      meta: { transitionName: 'slide' }
    },
    {
      path: '/programm',
      name: 'schedule',
      component: () => import(/* webpackChunkName: "schedule" */ './views/Schedule.vue'),
      meta: { transitionName: 'slide' }
    },
    {
      path: '/gastgeber-und-unterstuezer',
      name: 'sponsors',
      component: () => import(/* webpackChunkName: "sponsors" */ './views/Sponsors.vue'),
      meta: { transitionName: 'slide' }
    },
    {
      path: '/buecher',
      name: 'publishers',
      component: () => import(/* webpackChunkName: "publishers" */ './views/Publishers.vue'),
      meta: { transitionName: 'slide' }
    },
    {
      path: '/impressum',
      name: 'imprint',
      component: () => import(/* webpackChunkName: "imprint" */ './views/Imprint.vue'),
      meta: { transitionName: 'slide' }
    },
    {
      path: '/datenschutzerklaerung',
      name: 'privacy',
      component: () => import(/* webpackChunkName: "privacy" */ './views/Privacy.vue'),
      meta: { transitionName: 'slide' }
    },
    { path: '*', redirect: { name: 'home' } }
  ]

  /*
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
  */
})
